import React, { useState, useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { IconButton, Menu, MenuItem } from '@mui/material'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'

import { useModalContext } from '../../../../ui/modal'
import { AssignToDialog } from '../dialogs'
import { useApplicationsCalls } from '../../hooks/application-calls.hook'
import { ConfirmationDialog } from '../../../../ui'
import { requests } from '../../../../core/ajax'
import feedback from '../../../../core/feedback'
import { SwitchTeam } from '../dialogs/switch-team.component'

export const TableActions = (props) => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const location = useLocation()
  const { put } = requests
  const {
    actions: { open, close },
  } = useModalContext()
  const userRole = useSelector((state) => state.global.role)
  const operaciones = userRole === 'gestor' || userRole === 'delegado'
  const { getApplications, getGestorGc } = useApplicationsCalls()
  const searchParams = useSelector((state) => state.applications.search)
  const [anchorEl, setAnchorEl] = useState(null)

  const rowData = props.rowData || props.row?.original || props.cell?.row?.original
  const appId = rowData?.['id'] || rowData?.id
  const solicitud_id = rowData?.['solicitud_id'] || rowData?.solicitud_id

  console.log({
    propsRecibidas: props,
    rowDataExtraida: rowData,
    appIdFinal: appId,
    solicitudIdFinal: solicitud_id,
  })

  const handleGoToDetail = useCallback(
    (e) => {
      e.preventDefault()
      setAnchorEl(null)

      if (!appId) {
        console.error('No appId found for navigation')
        return
      }

      // Ensure appId is a valid string/number
      const validAppId = String(appId).trim()
      if (!validAppId || validAppId === 'undefined' || validAppId === 'null') {
        console.error('Invalid appId for navigation:', appId)
        return
      }

      const targetPath = `/applications/${validAppId}`

      navigate(targetPath, {
        state: { prevSearch: location.search },
      })
    },
    [navigate, appId, location.search]
  )

  if (!rowData) {
    return null
  }

  if (!appId) {
    return null
  }

  const handleOpenMenu = (event) => setAnchorEl(event.currentTarget)

  const handleCloseMenu = () => setAnchorEl(null)

  const handleOpenModal = (props) => {
    setAnchorEl(null)
    open({
      Component: AssignToDialog,
      data: { selectedRow: appId, getApplications, navigate, location },
    })
  }

  const switchApp = (gestor_id = 0) => {
    put(`/solicitudes/${appId}/switch_team`, { gestor_id })
      .then(() => {
        getApplications(searchParams)
        feedback(
          'success',
          formatMessage({ id: 'pages.applications.feedback.5' }, { id: solicitud_id })
        )
        close()
      })
      .catch(() => {
        feedback('error', formatMessage({ id: 'pages.applications.feedback.4' }))
        close()
      })
  }

  const handleAssign = async () => {
    setAnchorEl(null)
    if (operaciones) {
      const data = await getGestorGc(appId)
      if (data.gestor) {
        const gestorData = data.gestor.nombre + ' ' + data.gestor.apellidos
        open({
          Component: ConfirmationDialog,
          data: {
            title: formatMessage({ id: 'pages.applications.table.confirm.title.label' }),
            gestor: gestorData,
            text: formatMessage({ id: 'pages.applications.table.confirm.text.label' }),
            yesText: formatMessage({ id: 'global.accept' }),
            noText: formatMessage({ id: 'global.cancel' }),
            yesAction: switchApp,
            yesAndClose: false,
          },
          type: 'centered',
        })
      } else {
        open({
          Component: SwitchTeam,
          data: { handleAssign: switchApp, role: 'gestor_gc' },
        })
      }
    } else if (userRole === 'gestor_gc') {
      open({
        Component: SwitchTeam,
        data: { handleAssign: switchApp, role: 'gestor' },
      })
    }
  }

  const isReassignable = true

  return (
    <>
      <IconButton onClick={handleOpenMenu} size="large">
        <MoreHorizIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
        <MenuItem onClick={handleGoToDetail}>
          {formatMessage({
            id: `pages.applications.table.buttons.viewDetail${
              userRole === 'gestor' || userRole === 'delegado' ? '1' : '2'
            }.label`,
          })}
        </MenuItem>
        {isReassignable && (userRole === 'delegado' || userRole === 'gestor_gc') && (
          <MenuItem onClick={handleOpenModal}>
            {formatMessage({ id: 'pages.applications.table.buttons.reassign.label' })}
          </MenuItem>
        )}
      </Menu>
    </>
  )
}
